import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/States.api';

export const StatesRequest = (statesInputs) => ({
  type: actionTypes.STATES_CREATE_REQUEST,
  payload: statesInputs,
});
export const StatesSuccess = (states) => ({
  type: actionTypes.STATES_CREATE_SUCCESS,
  payload: states,
});

export const StatesFailure = (error) => ({
  type: actionTypes.STATES_CREATE_FAILURE,
  payload: error,
});


export const createStates = (statesInputs) => {
  return async (dispatch) => {
    dispatch(StatesRequest(statesInputs));
    try {
      const response = await api.createStates(statesInputs);
      if (response.status === 200 || response.status === 201) {
        dispatch(StatesSuccess(response.data.message));
        return { success: true };
      } else {
        dispatch(StatesFailure(response.data || 'state input failed'));
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      dispatch(StatesFailure(error.error || 'An error occurred'));
      return { success: false, message: error.error };
    }
  };
};


export const getStatesRequest = () => ({
  type: actionTypes.STATES_GET_REQUEST,
});

export const getStatesSuccess = (states) => ({
  type: actionTypes.STATES_GET_SUCCESS,
  payload: states,
});

export const getStatesFailure = (error) => ({
  type: actionTypes.STATES_GET_FAILURE,
  payload: error,
});

export const getStates = () => {
  return async (dispatch) => {
    dispatch(getStatesRequest());
    try {
      const states = await api.fetchStates();
      dispatch(getStatesSuccess(states));
      return { success: true, data: states };
    } catch (error) {
      dispatch(getStatesFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updateStatesRequest = (id, stateData) => ({
  type: actionTypes.STATES_UPDATE_REQUEST,
  payload: { id, stateData },
});

export const updateStatesSuccess = (message) => ({
  type: actionTypes.STATES_UPDATE_SUCCESS,
  payload: message,
});

export const updateStatesFailure = (error) => ({
  type: actionTypes.STATES_UPDATE_FAILURE,
  payload: error,
});

export const updateStatesById = (id, stateData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    stateData.updated_by = user.user_name;  // Add the user name to the stateData

    dispatch(updateStatesRequest(id, stateData));
    try {
      const response = await api.updateStates(id, stateData);
      dispatch(updateStatesSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateStatesFailure(error));
      return { success: false, message: error };
    }
  };
};

export const deleteStatesRequest = (id) => ({
  type: actionTypes.STATES_DELETE_REQUEST,
  payload: id,
});

export const deleteStatesSuccess = (message) => ({
  type: actionTypes.STATES_DELETE_SUCCESS,
  payload: message,
});

export const deleteStatesFailure = (error) => ({
  type: actionTypes.STATES_DELETE_FAILURE,
  payload: error,
});

export const deleteStatesById = (id) => {
  return async (dispatch) => {
    dispatch(deleteStatesRequest(id));
    try {
      const response = await api.deleteStates(id);
      dispatch(deleteStatesSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteStatesFailure(error));
      return { success: false, message: error };
    }
  };
};
